import {Form} from '@mintdata-wsp/common/components/form/Form';
import {IFormFieldState} from '@mintdata-wsp/common/components/formField/FormField';
import {Validators} from '@mintdata-wsp/common/components/validators/Validators';
import {ApiError} from '@mintdata-wsp/common/controllers/network/Fetcher';
import {RegisterRequest} from '@mintdata-wsp/common/controllers/network/generated/requests/RegisterRequest';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import {action} from 'mobx';
const md5 = require('md5');

export class LoginController
{
    public init()
    {
    }

    @action
    public submitForm(form:Form, nextPathname?:string)
    {
        const {loginPage} = rootState.ui;

        if( loginPage.isLoginInProgress || !form.areAllFieldsValid() || form.areSomeFieldIsEmpty() )
            return;

        let formData = form.getFormData();

        const email:any = formData.email;
        const password:any = formData.password;

        form.removeServerErrors();
        loginPage.isLoginInProgress = true;

        controllers.user.login(email, password)
            .then(() =>
            {
                if( nextPathname )
                {
                    controllers.navigation.navigateTo(nextPathname);
                }
                else
                {
                    controllers.navigation.toAppHome();
                }

                loginPage.isLoginInProgress = false;
            })
            .catch(action((err) =>
            {
                loginPage.isLoginInProgress = false;
                if( ApiError.isError(err) )
                {
                    form.setServerErrors((err as ApiError).message);
                }
            }));
    }

    public validateEmail(value:string, state:IFormFieldState<string>, form?:Form)
    {
        return Validators.validate({value, state, form},
            [
                Validators.emptyNotDirtyIsValid(),
                Validators.serverError('email'),
                Validators.email()
            ]);
    }

    public validatePassword(value:string, state:IFormFieldState<string>, form?:Form)
    {
        return Validators.validate({value, state, form},
            [
                Validators.emptyNotDirtyIsValid(),
                Validators.serverError('password'),
                Validators.password()
            ]);
    }

    @action
    public signInViaGoogle(email:string, fullname:string, id_token:string, form:Form)
    {
        const {loginPage} = rootState.ui;
        if( loginPage.isLoginInProgress)
            return;

        loginPage.isLoginInProgress = true;
        controllers.user.googleLogin(id_token).then(() =>
        {
            controllers.navigation.toAppHome();

            loginPage.isLoginInProgress = false;
        }).catch(action((err) =>
        {
            if( ApiError.isError(err) )
            {
                if ((err as ApiError).code === 401) { //user does not exists, navigating to registration page
                    console.log("User not found. Try to register");

                    const id:string = `${Math.floor(100000 + Math.random() * 900000)}`;

                    const orgName:string = `Organization ${id}`;
                    const orgSid:string = `org${id}`;

                    controllers.user.register(new RegisterRequest(
                        orgName,
                        orgSid,
                        fullname,
                        email.replace("@","_"),
                        md5(IdUtil.newGUID()),
                        email)
                    )
                        .then(()=>
                        {
                            controllers.navigation.toAppHome();
                        })
                        .catch(action((err)=>
                        {
                            loginPage.isLoginInProgress = false;
                            if (ApiError.isError(err))
                            {
                                form.setServerErrors((err as ApiError).message);
                            }
                        }));
                } else {
                    console.log("Security error");
                    loginPage.isLoginInProgress = false;
                    form.setServerErrors((err as ApiError).message);
                }
            }
        }));
    }

}
